import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

import 'rxjs/add/operator/catch';
import { HttpErrorResponse } from '@angular/common/http';
import { Login } from '../models/index';
import { FormControl, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { RegistrationValidator } from '../_helpers/register.validator';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  _login: Login = { password: '', email: '', token: '', userId: '', expDate: '' };
  isLoading: Boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) {}
  hasForgot = false;
  message = '';
  forgotEmail = '';
  newUser = false;
  confirmPW = '';
  isValidFormSubmitted = null;
  newUserCred: Login = { password: '', email: '', token: '', userId: '', expDate: '' };
  emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$';
  userFormGroup: FormGroup;
  successMessage: string;
  errorMessage: string;

  ngOnInit() {
    const currUser = localStorage.getItem('currentUser');
    if (JSON.parse(currUser)) {
      const userToken = JSON.parse(localStorage.getItem('currentUser')).token;
      const payload = atob(userToken.split('.')[1]);
      const expDate = JSON.parse(payload).exp;
      const d = new Date(0);
      d.setUTCSeconds(+expDate);
      if (d > new Date()) {
        this.router.navigate(['/manage']);
      } else {
        this.authService.logout();
      }
    }

    this.userFormGroup = this.formBuilder.group(
      {
        email: new FormControl({ value: '', disabled: this.isLoading }, [
          Validators.email,
          Validators.required
        ]),
        password: new FormControl('', Validators.required),
        token: new FormControl('', Validators.required)
      },
      {
        validator: RegistrationValidator.validate.bind(this)
      }
    );
  }

  error(err: HttpErrorResponse) {
    this.isLoading = false;
    console.log(err.error);
    this._login.password = '';
  }
  createAccount() {
    console.log('asd');
    this.isValidFormSubmitted = false;
    if (this.userFormGroup.invalid) {
      console.log('invalid');
      return;
    }
    this.isValidFormSubmitted = true;
    this.newUserCred = this.userFormGroup.value;
    this.userFormGroup.reset();
    this.authService.createAccount(this.newUserCred).subscribe(
      data => {
        this.createSuccess(data);
      },
      error => {
        this.createError(error);
      }
    );
  }
  createSuccess(data) {
    this.successMessage = 'Account created, please login to your new account';
    this.newUser = false;
    this.userFormGroup.reset();
  }
  cancelNew() {
    this.newUser = false;
    this.errorMessage = null;
    this.userFormGroup.reset();
  }

  createError(err) {
    this.errorMessage = err;
    this.userFormGroup.reset();
  }

  get email() {
    return this.userFormGroup.get('email');
  }
  get password() {
    return this.userFormGroup.get('password');
  }
  get token() {
    return this.userFormGroup.get('token');
  }

  reset() {
    this.authService.resetPassword(this._login).subscribe(
      resp => {
        this.message = 'Reset Email sent!';
        this.hasForgot = false;
      },
      error => this.error(error)
    );
  }

  login() {
    if (this._login.email && this._login.password) {
      this.isLoading = true;
      this.authService.login(this._login).subscribe(
        user => {
          if (user && user.token) {
            localStorage.setItem('currentUser', JSON.stringify(user));
            // this.cookieService.set('currentUser', JSON.stringify(user));
          }
          this.authService.authChange.emit();
          this.router.navigate(['/manage']);
        },
        error => this.error(error)
      );
    }
  }

  logout() {
    this.authService.logout();
  }
}
